export default "/_assets/icon-check.4012a9d0.svg"